import React, { useContext, useEffect, useId, useState } from "react";
import {
  actionPermissionApi,
  createNewLr,
  fetchLrNumberData,
  getDataLrDetails,
  updateNewLr,
} from "_services/accountsServices/lrServices";
import { getBranchDropdownListData } from "_services/dropdownServices/dropdownService";
import {
  CityDropdownForTrip,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CommonSwitch,
  CommonTextarea,
  CrossButton,
  CustomSelect,
} from "components";
import { UserContext } from "context";
import { actionPermission, utils } from "helper";
import AddNewSeriesModal from "modals/AddNewSeriesModal";
import LrSeriesModal from "modals/LrSeriesModal";
import StorageService from "utils/StorageServices/StorageServices";
import SelectUnitLrModal from "modals/SelectUnitLrModal";
import SelectConsigneeLrModal from "modals/SelectConsigneeLrModal";
import AddEditConsignee from "modals/AddEditConsignee";
import AddEditUnitModal from "modals/AddEditUnitModal";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { FaTrash } from "react-icons/fa";
import { getMaterialListData } from "_services/materialServices/materialServices";
import { getMaterialCategoryListData } from "_services/materialServices/materialCategoryServices";
import AddItemModal from "modals/AddItemModal";
import AddItemGroupModal from "modals/AddItemGroupModal";
import AddEditBranch from "modals/AddEditBranch";
import { fetchSingleUnitData } from "_services/accountsServices/unitServices";
import { fetchConsigneeDetailsData } from "_services/accountsServices/consigneeServices";
import moment from "moment";
import { getAddressDetailsApi } from "_services/accountsServices/addressBookService";
import AddAddressBook from "modals/AddAddressBook";
import { getCityLocationList } from "_services/accountsServices/cityLocationService";
import SingleSelectDropdownInfinite from "components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite";
import AddLocationModal from "modals/AddLocationModal";
import { FaRegImage, FaTreeCity, FaYoutube } from "react-icons/fa6";
import { handleKeyDown, uploadFiles } from "_services";
import { RxCross2 } from "react-icons/rx";
import { MdOutlineFileDownload, MdOutlineRemoveRedEye } from "react-icons/md";
import { BsFiletypeXlsx, BsFillFileEarmarkPdfFill } from "react-icons/bs";
import ImagePreview from "modals/LrDetailModal/ImagePreview";
import { deleteImage } from "_services/accountsServices/supplierServices";
import './addEditModal.css';
import { getEwayBillLrData } from "_services/accountsServices/ewayBillServices";
import { constant } from 'constants/constant'
import EbillExtentionModal from "modals/EbillExtentionModal";
import YoutubeModal from "modals/YoutubeModal";

const AddEditLrModal = (props) => {
  let { isOpen, onClose, callBackDataLr, type, callGetData = () => { } } = props;

  const idUniq = useId();

  let ewayCondition = isOpen?.ewayModal;

  const formObj = {
    invoice_date: "",
    invoice_time: "",
    consignor_id: "",
    branch_id: {},
    from_location: {},
    from_state: "",
    to_location: {},
    to_state: "",
    unit_id: "",
    consignee_id: "",
    invoice_number: "",
    loading_slip_number: "",
    gst_invoice_number: "",
    po_number: "",
    lr_number: "",
    mlr_number: "",
    company_id: StorageService.getCompanyId(),
    eway_bill_number: null,
    eway_bill_date: new Date(),
    eway_expiry_date: "",
    freight_type: "",
    total_qty: "",
    rate: "",
    total_amount: "",
    attachment_file: [],
    remarks: "",
    lr_material_list:
      (isOpen?.permission_at_item?.item?.view === 1 ||
        isOpen?.permission_at_item?.item_desc?.view === 1 ||
        isOpen?.permission_at_item?.item_group_hsn?.view === 1 ||
        isOpen?.permission_at_item?.kot?.view === 1 ||
        isOpen?.permission_at_item?.qty?.view === 1 ||
        isOpen?.permission_at_item?.sales?.view === 1 ||
        isOpen?.permission_at_item?.weight?.view === 1)
        ? [
          {
            product_desc: "",
            name: "",
            material_code: "",
            hsn_code: null,
            material_category_id: null,
            qty: 0,
            qty_type: 1,
            weight: 0,
            weight_type: 1,
            kot: 0,
            amount: 0,
          },
        ]
        : [],
  };

  const {
    masterData,
    cities,
    modalZIndex,
    setModalZIndex,
    setIsMaterialIndex,
    isMaterialIndex,
    setFromStationToUnit,
    fromStationToUnit,
    lrModalToggleForEway, setLrModalToggleForEway,
    ewayBillLrData, setEwayBillLrData,
    mastersChild, youtubeVideos, setYoutubeVideos
  } = useContext(UserContext);

  const masterChildBranch = mastersChild?.find((i) => i?.label === "Branch");

  const [formValue, setFormValue] = useState(formObj);
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);
  const [ewayBillLoading, setEwayBillLoading] = useState(false);
  const [unitInLR, setUnitInLR] = useState(false);
  const [consigneeInLR, setConsigneeInLR] = useState(false);
  const [dropdownBranchList, setDropdownBranchList] = useState([]);
  const [isOpenLrSeries, setIsOpenLrSeries] = useState(false);
  const [showAddNewLrSeries, setShowAddNewLrSeries] = useState(false);
  const [isSetLrSeries, setIsSetLrSeries] = useState("");
  const [isLrNumber, setIsLrNumber] = useState("");
  const [isEditLR, setIsEditLR] = useState(false);
  const [addNewConsignee, setAddNewConsignee] = useState(false);
  const [selectConsigneeData, setSelectConsigneeData] = useState({});
  const [addNewUnit, setAddNewUnit] = useState(false);
  const [selectUnitData, setSelectUnitData] = useState({});
  const [materialList, setMaterialList] = useState([]);
  const [materialCategoryList, setMaterialCategoryList] = useState([]);
  const [showAddItem, setShowAddItem] = useState(false);
  const [showAddGroupItem, setShowAddGroupItem] = useState(false);
  const [addNewBranch, setAddNewBranch] = useState(false);
  const [dataSingleConsignee, setDataSingleConsignee] = useState({});
  const [dataSingleUnit, setDataSingleUnit] = useState({});
  const [ewayBillRadioToggle, setEwayBillRadioToggle] = useState(false);
  const [freightRadioToggle, setFreightRadioToggle] = useState(true);

  const [attachments, setAttachments] = useState([]);
  const [imagePreview, setImagePreview] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [consignorName, setConsignorName] = useState({});

  const [startDate, setStartDate] = useState(
    new Date()
  );
  const [ewayBillStartDate, setEwayBillStartDate] = useState(
    new Date()
  )
  const [openLoction, setOpenLoction] = useState(false)
  const [isLrStatus, setIsLrStatus] = useState(0);

  const [isEditMaterialTable, setIsEditMaterialTable] = useState([]);
  const [typeOfDropdown, setTypeOfDropdown] = useState("");

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [addressId, setAddressId] = useState({
    id: "",
    title: "address",
    view: false,
  });

  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    messageType: null,
    templateId: null,
    templateData: {}
  });

  const createDynamicSchema = () => {
    return Yup.object().shape({
      invoice_date: Yup.string().required("Required * "),
      from_location: Yup.object().shape({
        name: Yup.string().required("From location is Required * "),
      }),
      to_location: Yup.object().shape({
        name: Yup.string().required("To location is Required * "),
      }),
      branch_id: Yup.object().shape({
        label: Yup.string().required("Required * "),
      }),
      eway_expiry_date: (formValue?.eway_bill_number?.length === 12) ?
        Yup.string().required("Required * ") : Yup.string().notRequired(),
      invoice_number:
        isOpen?.permission_at_invoice_number?.view === 1 &&
          isOpen?.permission_at_invoice_number?.mandatory === 1
          ? Yup.string().min(isOpen?.permission_at_invoice_number?.min ? isOpen?.permission_at_invoice_number?.min : 8, `Must be more than ${isOpen?.permission_at_invoice_number?.min} digit `).max(isOpen?.permission_at_invoice_number?.max ? isOpen?.permission_at_invoice_number?.max : 12, `Must be less than ${isOpen?.permission_at_invoice_number?.max}`).required("Required * ")
          : Yup.string().notRequired(),
      loading_slip_number:
        isOpen?.permission_at_field2?.view === 1 &&
          isOpen?.permission_at_field2?.mandatory === 1
          ? Yup.string().min(isOpen?.permission_at_field2?.min ? isOpen?.permission_at_field2?.min : 8, `Must be more than ${isOpen?.permission_at_field2?.min} digit `).max(isOpen?.permission_at_field2?.max ? isOpen?.permission_at_field2?.max : 12, `Must be less than ${isOpen?.permission_at_field2?.max}`).required("Required * ")
          : Yup.string().notRequired(),
      gst_invoice_number:
        isOpen?.permission_at_field3?.view === 1 &&
          isOpen?.permission_at_field3?.mandatory === 1
          ? Yup.string().min(isOpen?.permission_at_field3?.min ? isOpen?.permission_at_field3?.min : 8, `Must be more than ${isOpen?.permission_at_field3?.min} digit `).max(isOpen?.permission_at_field3?.max ? isOpen?.permission_at_field3?.max : 12, `Must be less than ${isOpen?.permission_at_field3?.max}`).required("Required * ")
          : Yup.string().notRequired(),
      po_number:
        isOpen?.permission_at_field4?.view === 1 &&
          isOpen?.permission_at_field4?.mandatory === 1
          ? Yup.string().min(isOpen?.permission_at_field4?.min ? isOpen?.permission_at_field4?.min : 8, `Must be more than ${isOpen?.permission_at_field4?.min} digit `).max(isOpen?.permission_at_field4?.max ? isOpen?.permission_at_field4?.max : 12, `Must be less than ${isOpen?.permission_at_field4?.max}`).required("Required * ")
          : Yup.string().notRequired(),
      mlr_number:
        isOpen?.permission_at_field5?.view === 1 &&
          isOpen?.permission_at_field5?.mandatory === 1
          ? Yup.string().min(isOpen?.permission_at_field5?.min ? isOpen?.permission_at_field5?.min : 8, `Must be more than ${isOpen?.permission_at_field5?.min} digit `).max(isOpen?.permission_at_field5?.max ? isOpen?.permission_at_field5?.max : 12, `Must be less than ${isOpen?.permission_at_field5?.max}`).required("Required * ")
          : Yup.string().notRequired(),
      eway_bill_number:
        isOpen?.permission_at_lr?.eway_bill_mandatory === 1
          ? Yup.string().required("Required * ")
          : Yup.string().notRequired(),
      unit_id:
        isOpen?.permission_at_lr?.unit_mandatory === 1
          ? Yup.string().required("Unit is Required * ")
          : Yup.string().notRequired(),
      consignee_id:
        isOpen?.permission_at_lr?.consignee_mandatory === 1
          ? Yup.string().required("Consignee is Required * ")
          : Yup.string().notRequired(),
      lr_material_list:
        (isOpen?.permission_at_item_parent && (isOpen?.permission_at_item?.item?.view === 1 ||
          isOpen?.permission_at_item?.item_desc?.view === 1 ||
          isOpen?.permission_at_item?.item_group_hsn?.view === 1 ||
          isOpen?.permission_at_item?.kot?.view === 1 ||
          isOpen?.permission_at_item?.qty?.view === 1 ||
          isOpen?.permission_at_item?.sales?.view === 1 ||
          isOpen?.permission_at_item?.weight?.view === 1))
          ? Yup.array().of(
            Yup.object().shape({
              product_desc:
                (isOpen?.permission_at_item?.item_desc?.view === 1 && isOpen?.permission_at_item?.item_desc?.mandatory === 1)
                  ? Yup.string().required("Required * ")
                  : Yup.string().notRequired(),
              name:
                (isOpen?.permission_at_item?.item?.view === 1 && isOpen?.permission_at_item?.item?.mandatory === 1)
                  ? Yup.string().required("Required * ")
                  : Yup.string().notRequired(),
              material_category_id:
                (isOpen?.permission_at_item?.item_group_hsn?.view === 1 && isOpen?.permission_at_item?.item_group_hsn?.mandatory === 1)
                  ? Yup.string().required("Required * ")
                  : Yup.mixed().notRequired(),
              hsn_code:
                (isOpen?.permission_at_item?.item_group_hsn?.view === 1 && isOpen?.permission_at_item?.item_group_hsn?.mandatory === 1)
                  ? Yup.string().required("Required * ")
                  : Yup.mixed().notRequired(),
              qty:
                (isOpen?.permission_at_item?.qty?.view === 1 && isOpen?.permission_at_item?.qty?.mandatory === 1)
                  ? Yup.number()
                    .typeError('Required * ')
                    .required('Required * ')
                    .moreThan(0, 'Required * ')
                  : Yup.string().notRequired(),
              weight:
                (isOpen?.permission_at_item?.weight?.view === 1 && isOpen?.permission_at_item?.weight?.mandatory === 1)
                  ? Yup.number()
                    .typeError('Required * ')
                    .required('Required * ')
                    .moreThan(0, 'Required * ')
                  : Yup.string().notRequired(),
              kot:
                (isOpen?.permission_at_item?.kot?.view === 1 && isOpen?.permission_at_item?.kot?.mandatory === 1)
                  ? Yup.number()
                    .typeError('Required * ')
                    .required('Required * ')
                    .moreThan(0, 'Required * ')
                  : Yup.string().notRequired(),
              amount:
                (isOpen?.permission_at_item?.sales?.view === 1 && isOpen?.permission_at_item?.sales?.mandatory === 1)
                  ? Yup.number()
                    .typeError('Required * ')
                    .required('Required * ')
                    .moreThan(0, 'Required * ')
                  : Yup.string().notRequired(),
            })
          )
          : Yup.array().notRequired(),
    });
  };

  const schema = createDynamicSchema();

  const handleOnChange = async (name, value) => {
    const stateObj = { ...formValue, [name]: value };
    if (name === 'eway_bill_date') {
      stateObj['eway_expiry_date'] = new Date();
    }
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.dynamicCheckFormError(
        stateObj,
        schema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...formValue, [name]: item };
    if (name === 'freight_type') {
      stateObj['total_amount'] = ''
      stateObj['rate'] = ''
      stateObj['total_qty'] = ''
    }
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.dynamicCheckFormError(
        stateObj,
        schema
      );
      if (validationResult === true) {
        setFormError({});
      } else {
        setFormError(validationResult);
      }
    }
  };

  const fetchFromCity = async (search, page, limit) => {
    const res = await getCityLocationList({
      countryCode: "IN",
      stateCode: "",
      offset: page,
      limit,
      search,

    });
    if (res?.responseCode === 200) {
      const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };



  const getTableMaterialListData = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        limit: 100,
        offset: 1,
        search: "",
      };
      const res = await getMaterialListData(object);
      if (res?.responseCode == 200) {
        setMaterialList(res?.data?.materials);
      }
    } catch (error) {
      // throw error;
    }
  };

  const getTableMaterialCategoryListData = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        limit: 100,
        offset: 1,
        search: "",
      };
      const res = await getMaterialCategoryListData(object);
      if (res?.responseCode == 200) {
        setMaterialCategoryList(res?.data?.material_categorys);
      }
    } catch (error) {
      // throw error;
    }
  };

  useEffect(() => {
    getTableMaterialListData();
    getTableMaterialCategoryListData();
  }, [showAddItem, showAddGroupItem]);

  const apiCallingFunction = async () => {
    try {
      if (!!isOpen?.isEditLr) {
        let tableArray = formValue?.lr_material_list?.map((el) => {
          return {
            ...el,
            material_category_id: el?.material_category_id != '' ? el?.material_category_id : null,
            hsn_code: el?.hsn_code != '' ? el?.hsn_code : null,
            kot: el?.kot != null ? el?.kot : 0,
            qty: el?.qty != null ? el?.qty : 0,
            weight: el?.weight != null ? el?.weight : 0,
            amount: el?.amount != null ? el?.amount : 0,
          }
        })
        tableArray?.forEach(obj => {
          if (isOpen?.permission_at_item?.item_group_hsn?.view !== 1) {
            delete obj.hsn_code;
          }
          if (isOpen?.permission_at_item?.kot?.view !== 1) {
            delete obj.kot;
          }
          if (isOpen?.permission_at_item?.qty?.view !== 1) {
            delete obj.qty;
          }
          if (isOpen?.permission_at_item?.weight?.view !== 1) {
            delete obj.weight;
          }
          if (isOpen?.permission_at_item?.sales?.view !== 1) {
            delete obj.amount;
          }
        });
        let isTableLr = (isOpen?.permission_at_item?.item?.view === 1 ||
          isOpen?.permission_at_item?.item_desc?.view === 1 ||
          isOpen?.permission_at_item?.item_group_hsn?.view === 1 ||
          isOpen?.permission_at_item?.kot?.view === 1 ||
          isOpen?.permission_at_item?.qty?.view === 1 ||
          isOpen?.permission_at_item?.sales?.view === 1 ||
          isOpen?.permission_at_item?.weight?.view === 1) ?
          tableArray : [];
        let object = {
          company_id: StorageService.getCompanyId(),
          contract_id: isOpen?.contract?._id ? isOpen?.contract?._id : '',
          lr_id: formValue?._id,
          remarks: formValue?.remarks,
          branch_id: formValue?.branch_id?.value,
          freight_type: formValue?.freight_type?.value,
          from_location: formValue?.from_location?.name,
          from_state: formValue?.from_location?.stateName,
          to_location: formValue?.to_location?.name,
          to_state: formValue?.to_location?.stateName,
          unit_id: selectUnitData?.value ? selectUnitData?.value : '',
          consignee_id: selectConsigneeData?.value ? selectConsigneeData?.value : '',
          consignor_id: formValue?.consignor_id,
          eway_bill_date: formValue?.eway_bill_date != null ? formValue?.eway_bill_date : '',
          eway_bill_number: formValue.eway_bill_number ? formValue.eway_bill_number : null,
          total_qty: (formValue?.freight_type?.value != 6) ? (formValue?.total_qty != null ? formValue?.total_qty : '') : '',
          rate: (formValue?.freight_type?.value != 6) ? (formValue?.rate != null ? formValue?.rate : '') : '',
          total_amount: (formValue?.freight_type?.value != 6) ? ((formValue.rate * formValue.total_qty > 0 && formValue.rate * formValue.total_qty != null) ? formValue.rate * formValue.total_qty : '') : ((formValue.total_amount > 0 && formValue?.total_amount != null) ? formValue.total_amount : ''),
          lr_material_list: isTableLr,
          invoice_number: formValue?.invoice_number,
          invoice_date: formValue?.invoice_date,
          loading_slip_number: formValue?.loading_slip_number,
          gst_invoice_number: formValue?.gst_invoice_number,
          po_number: formValue?.po_number,
          mlr_number: formValue?.mlr_number,
          eway_expiry_date: (formValue?.eway_bill_number?.toString()?.length === 12) ? (formValue?.eway_expiry_date ? utils.parseUTCAsLocal(formValue?.eway_expiry_date) : '') : '',
          invoice_time: new Date().toLocaleString("en-US", {
            timeStyle: "short",
          }),
          attachment_file: attachments?.length > 0 ? attachments?.map((item) => {
            return {
              filename: item?.filename,
              path: item?.path,
            }
          }) : [],
        };
        const res = await updateNewLr(object);
        if (res?.responseCode === 200) {
          if (type === "from_trip") {
            callBackDataLr(res?.data?.lr)
          }
          setFormValue({});
          setLoading(false);
          toast.success("LR Update Successfully");
          callGetData();
          onClose();
        } else {
          if (res?.responseMessage) {
            toast.error(res?.responseMessage);
          }
          setLoading(false);
        }
      } else {
        let tableArray = formValue?.lr_material_list?.map((el) => {
          return {
            ...el,
            material_category_id: el?.material_category_id != '' ? el?.material_category_id : null,
            hsn_code: el?.hsn_code != '' ? el?.hsn_code : null,
            kot: el?.kot != null ? el?.kot : 0,
            qty: el?.qty != null ? el?.qty : 0,
            weight: el?.weight != null ? el?.weight : 0,
            amount: el?.amount != null ? el?.amount : 0,
          }
        })
        tableArray?.forEach(obj => {
          if (isOpen?.permission_at_item?.item_group_hsn?.view !== 1) {
            delete obj.hsn_code;
          }
          if (isOpen?.permission_at_item?.kot?.view !== 1) {
            delete obj.kot;
          }
          if (isOpen?.permission_at_item?.qty?.view !== 1) {
            delete obj.qty;
          }
          if (isOpen?.permission_at_item?.weight?.view !== 1) {
            delete obj.weight;
          }
          if (isOpen?.permission_at_item?.sales?.view !== 1) {
            delete obj.amount;
          }
        });
        let isTableLr = (isOpen?.permission_at_item?.item?.view === 1 ||
          isOpen?.permission_at_item?.item_desc?.view === 1 ||
          isOpen?.permission_at_item?.item_group_hsn?.view === 1 ||
          isOpen?.permission_at_item?.kot?.view === 1 ||
          isOpen?.permission_at_item?.qty?.view === 1 ||
          isOpen?.permission_at_item?.sales?.view === 1 ||
          isOpen?.permission_at_item?.weight?.view === 1) ?
          tableArray : [];
        let object = {
          ...formValue,
          contract_id: isOpen?.contract?._id ? isOpen?.contract?._id : '',
          branch_id: formValue?.branch_id?.value,
          freight_type: formValue?.freight_type?.value,
          from_location: formValue?.from_location?.name,
          from_state: formValue?.from_location?.stateName,
          to_location: formValue?.to_location?.name,
          to_state: formValue?.to_location?.stateName,
          unit_id: selectUnitData?.value,
          consignee_id: selectConsigneeData?.value,
          eway_bill_number: formValue.eway_bill_number ? formValue.eway_bill_number : null,
          eway_expiry_date: (formValue?.eway_bill_number?.toString()?.length === 12) ? (formValue?.eway_expiry_date ? utils.parseUTCAsLocal(formValue?.eway_expiry_date) : '') : '',
          is_eway_fetch: formValue.eway_bill_number != null && false,
          total_qty: (formValue?.freight_type?.value != 6) ? (formValue?.total_qty != null ? formValue?.total_qty : '') : '',
          rate: (formValue?.freight_type?.value != 6) ? (formValue?.rate != null ? formValue?.rate : '') : '',
          total_amount: (formValue?.freight_type?.value != 6) ? ((formValue.rate * formValue.total_qty > 0 && formValue.rate * formValue.total_qty != null) ? formValue.rate * formValue.total_qty : '') : ((formValue.total_amount > 0 && formValue?.total_amount != null) ? formValue.total_amount : ''),
          lr_material_list: isTableLr,
          invoice_time: new Date().toLocaleString("en-US", {
            timeStyle: "short",
          }),
          attachment_file: attachments?.length > 0 ? attachments?.map((item) => {
            return {
              filename: item?.filename,
              path: item?.path,
            }
          }) : [],
        };
        if (object.eway_bill_number === null) {
          delete object.is_eway_fetch;
        }
        delete object.expense_charges;
        delete object.lr_number;
        delete object.contract;
        delete object.expense_charges;
        const res = await createNewLr(object);
        if (res?.responseCode === 200) {
          if (type === "from_trip") {
            callBackDataLr(res?.data?.lr)
          }
          setFormValue({});
          setLoading(false);
          toast.success("LR Created Successfully");
          callGetData();
          onClose();
        } else {
          if (res?.responseMessage) {
            toast.error(res?.responseMessage);
          }
          setLoading(false);
        }
      }
      setEwayBillLrData({});
    } catch (error) {
      setLoading(false);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationResult = await utils.dynamicCheckFormError(
      formValue,
      schema
    );
    if (utils?.isObjectKeyEmpty(validationResult)) {
      setLoading(true);
      apiCallingFunction();
      setFormError("");
    } else {
      setFormError(validationResult);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen?.isEditLr && !ewayCondition) {
      setFormValue((s) => ({
        ...s,
        freight_type: isOpen?.contract?.rate_type?.length > 0 ? {
          label: isOpen?.contract?.rate_type[0]?.name,
          value: isOpen?.contract?.rate_type[0]?.id,
        } : "",
        consignor_id: isOpen?._id,
        from_location: isOpen?.from_city,
        to_location: isOpen?.to_city,
        branch_id: dropdownBranchList?.map((el) => {
          return {
            label: el?.branch,
            value: el?._id,
          };
        })[0],
      }));
    }
  }, [dropdownBranchList]);

  const getDropdownDataBranchList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        limit: 100,
        offset: 1,
        search: "",
        firm_id: isOpen?.firm_id?._id || ""
      };
      const res = await getBranchDropdownListData(object);
      if (res?.responseCode === 200) {
        setDropdownBranchList(res?.data?.branch_list?.reverse());
      }
    } catch (error) {
      // throw error;
    }
  };

  const getDataLrNumber = async (id) => {
    try {
      let object = {
        branch_id: id,
      };
      const res = await fetchLrNumberData(object);
      if (res?.responseCode == 200) {
        setFormValue((s) => ({ ...s, lr_number: res?.data?.lr_number }));
      }
    } catch (error) {
      // throw error;
    }
  };

  useEffect(() => {
    if (!isOpen?.isEditLr && isLrStatus != 1 && !ewayCondition) {
      if (formValue?.branch_id?.value) {
        getDataLrNumber(formValue?.branch_id?.value);
      }
    }
  }, [formValue?.branch_id, isSetLrSeries]);

  let unitInLrModal = {
    isOpen: unitInLR,
    closeModal: (e) => setUnitInLR(false),
    nextModal: (e) => setAddNewUnit(true),
    selectUnit: (e) => setSelectUnitData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Select Address",
    submitTitle: "Submit",
    location_point: 1,
    consignor_id: isOpen?._id,
    firmId: isOpen?.firm_id
  };

  let consigneeInLrModal = {
    isOpen: consigneeInLR,
    closeModal: (e) => setConsigneeInLR(false),
    nextModal: (e) => setAddNewConsignee(true),
    selectConsignee: (e) => setSelectConsigneeData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Select Address",
    submitTitle: "Submit",
    location_point: 2,
    consignor_id: isOpen?._id,
    firmId: isOpen?.firm_id
  };

  const handleLrFunctionality = () => {
    if (!isOpen?.isEditLr) {
      setIsOpenLrSeries(true);
    }
  };

  let isLrSeriesModalProps = {
    isOpen: isOpenLrSeries,
    closeModal: () => setIsOpenLrSeries(!isOpenLrSeries),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Select LR Series",
    formData: formValue,
    submitTitle: "Save",
    nextModal: (e) => setShowAddNewLrSeries(true),
    setIsEditLR: (e) => setIsEditLR(e),
    setLrSeries: (e) => setIsSetLrSeries(e),
    setIsLrNumber: (e) => setIsLrNumber(e),
  };

  let addNewSeriesModalProps = {
    isOpen: showAddNewLrSeries,
    closeModal: () => setShowAddNewLrSeries(!showAddNewLrSeries),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: isEditLR?._id ? "Edit New Series" : "Add New Series",
    submitTitle: isEditLR?._id ? "Update" : "Save",
    formData: formValue,
    isEditLR: isEditLR,
    onSubmit: (e) => setShowAddNewLrSeries(false),
    previosModal: () => setIsOpenLrSeries(!isOpenLrSeries),
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const getSingleConsigneeData = async (id) => {
    try {
      let object = {
        addressbook_id: id,
        company_id: StorageService.getCompanyId(),
      };
      const res = await getAddressDetailsApi(object);
      if (res?.responseCode == 200) {
        setDataSingleConsignee(res?.data?.book_detail);
      }
    } catch (error) {
      // throw error;
    }
  };

  const getSingleUnitData = async (id) => {
    try {
      let object = {
        addressbook_id: id,
        company_id: StorageService.getCompanyId(),
      };
      const res = await getAddressDetailsApi(object);
      if (res?.responseCode == 200) {
        setDataSingleUnit(res?.data?.book_detail);
      }
    } catch (error) {
      // throw error;
    }
  };

  useEffect(() => {
    if (selectConsigneeData?.value) {

      const stateObj = {
        ...formValue,
        consignee_id: selectConsigneeData?.value,
        to_location: {
          label: selectConsigneeData?.state?.label ? `${selectConsigneeData?.city?.label}, ${selectConsigneeData?.state?.label}` : "",
          name: selectConsigneeData?.city?.label || "",
          stateName: selectConsigneeData?.state?.label || "",
          _id: selectConsigneeData?.city?.label || ""
        }
      };
      setFormValue(stateObj);

      if (!utils.isObjectKeyEmpty(formError)) {
        const validationResult = utils.dynamicCheckFormError(
          stateObj,
          schema
        );
        if (validationResult === true) {
          setFormError("");
        } else {
          setFormError(validationResult);
        }
      }
      getSingleConsigneeData(selectConsigneeData?.value);
    }
  }, [selectConsigneeData?.value]);

  useEffect(() => {

    if (selectUnitData?.value) {
      const stateObj = {
        ...formValue,
        unit_id: selectUnitData?.value,
        from_location: {
          label: selectUnitData?.state?.label ? `${selectUnitData?.city?.label}, ${selectUnitData?.state?.label}` : "",
          name: selectUnitData?.city?.label || "",
          stateName: selectUnitData?.state?.label || "",
          _id: selectUnitData?.city?.label || ""
        }
      };
      setFormValue(stateObj);

      if (!utils.isObjectKeyEmpty(formError)) {
        const validationResult = utils.dynamicCheckFormError(
          stateObj,
          schema
        );
        if (validationResult === true) {
          setFormError("");
        } else {
          setFormError(validationResult);
        }
      }
      getSingleUnitData(selectUnitData?.value);
    }
  }, [selectUnitData?.value]);

  const addNewTableRowHandler = () => {
    setFormValue((state) => ({
      ...state,
      lr_material_list: [
        ...formValue.lr_material_list,
        {
          name: "",
          material_code: "",
          hsn_code: null,
          material_category_id: null,
          qty: 0,
          qty_type: 1,
          weight: 0,
          weight_type: 1,
          kot: 0,
          amount: 0,
        },
      ],
    }));
  };

  const handleRemoveClick = (e, index) => {
    e.preventDefault();
    const list = [...formValue?.lr_material_list];
    list.splice(index, 1);
    setFormValue((state) => ({ ...state, lr_material_list: list }));
  };

  const lrHandleKeyDown = (e, name) => {
    if (['amount', 'qty', 'weight', 'hsn_code'].includes(name)) {
      if (e.key === 'E' || e.key === 'e' || e.key === '-' || e.key === '+' || e.key === '.') {
        e.preventDefault();
      }
    } else {
      if (e.key === 'E' || e.key === 'e' || e.key === '-' || e.key === '+') {
        e.preventDefault();
      }
    }
  };

  const handleInputChange = async (e, index) => {
    const { name, value } = e.target;
    const list = [...formValue?.lr_material_list];
    if (name === 'amount' || name === 'qty' || name === 'weight' || name === 'kot') {
      if (!/^\d*\.?\d*$/.test(value)) return;

      let formattedValue = value;
      if (value.includes(".")) {
        const [integer, decimal] = value.split(".");
        formattedValue = `${integer}.${decimal.substring(0, 2)}`;
      }
      list[index][name] = formattedValue;
    } else if (name === 'hsn_code') {
      const cleanedValue = value.replace(/\D/g, "");
      list[index][name] = cleanedValue;
    } else {
      list[index][name] = value;
    }

    const stateObj = { ...formValue, lr_material_list: list };
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const error = await utils.checkFormError(stateObj, schema);
      setFormError(error);
    }
  };

  const handleInputChangeSelect1 = async (item, name, index) => {
    const list = [...formValue?.lr_material_list];
    list[index][name] = item?.label;
    list[index]["material_code"] = item?.material_code;
    list[index]["material_category_id"] = item?.material_category_id;
    list[index]["hsn_code"] = item?.hsn_code

    const stateObj = { ...formValue, lr_material_list: list };
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.dynamicCheckFormError(
        stateObj,
        schema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleInputChangeSelect2 = async (item, name, index) => {

    const list = [...formValue?.lr_material_list];
    list[index][name] = item?.value;
    if (item?.hsn_code) {
      list[index]["hsn_code"] = item?.hsn_code
    }

    const stateObj = { ...formValue, lr_material_list: list };
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.dynamicCheckFormError(
        stateObj,
        schema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  let firstAddItemModal = {
    isOpen: showAddItem,
    materialCategoryList: materialCategoryList,
    closeModal: (e) => setShowAddItem(false),
    isCurrentModal: (e) => setShowAddItem(false),
    nextModal: (e) => setShowAddGroupItem(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Material", // Add Item
    submitTitle: "Add Material", // Add Item
    modalZIndex: modalZIndex,
  };

  const closeAllModal = async (e) => {
    setModalZIndex(null);
    setShowAddItem(false);
    setShowAddGroupItem(false);
  }

  let firstAddGroupItemModal = {
    isOpen: showAddGroupItem,
    closeModal: (e) => closeAllModal(e),
    isCurrentModal: (e) => setShowAddGroupItem(false),
    previousModal: (e) => setShowAddItem(true),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Material Category", // Add Item Group
    submitTitle: "Add Material Category", // Add Item Group
  };

  useEffect(() => {
    if (
      ((isOpen?.permission_at_item?.item?.view === 1 && isOpen?.permission_at_item?.item_group_hsn?.view === 1) ||
        isOpen?.permission_at_item?.item_desc?.view === 1 ||
        isOpen?.permission_at_item?.kot?.view === 1 ||
        isOpen?.permission_at_item?.qty?.view === 1 ||
        isOpen?.permission_at_item?.sales?.view === 1 ||
        isOpen?.permission_at_item?.weight?.view === 1) &&
      materialList.length > 0 &&
      materialCategoryList.length > 0 &&
      !isOpen?.isEditLr &&
      !ewayCondition
    ) {
      const list = [...formValue?.lr_material_list];
      list.splice(isMaterialIndex, 1, {
        ...list[isMaterialIndex],
        name: materialList?.at(-1)?.name,
        product_desc: "",
        material_code: materialList?.at(-1)?.material_code,
        material_category_id: materialCategoryList?.at(-1)?._id,
        hsn_code: materialCategoryList?.at(-1)?.hsn_code ? materialCategoryList?.at(-1)?.hsn_code : materialList?.at(-1)?.hsn_code,
        qty_type: materialList?.at(-1)?.qty_type,
        qty: materialList?.at(-1)?.qty,
        weight: materialList?.at(-1)?.weight ? materialList?.at(-1)?.weight : 0,
        weight_type: materialList?.at(-1)?.weight_type,
        kot: materialList?.at(-1)?.kot ? materialList?.at(-1)?.kot : 0,
        amount: materialList?.at(-1)?.amount,
      });
      setFormValue((s) => ({ ...s, lr_material_list: list }));
    }
  }, [
    isOpen?.permission_at_item,
    materialList,
    materialCategoryList,
    !showAddGroupItem,
  ]);

  // edit lr table condition - start

  useEffect(() => {
    if (
      ((isOpen?.permission_at_item?.item?.view === 1 && isOpen?.permission_at_item?.item_group_hsn?.view === 1) ||
        isOpen?.permission_at_item?.item_desc?.view === 1 ||
        isOpen?.permission_at_item?.kot?.view === 1 ||
        isOpen?.permission_at_item?.qty?.view === 1 ||
        isOpen?.permission_at_item?.sales?.view === 1 ||
        isOpen?.permission_at_item?.weight?.view === 1) &&
      materialList.length > 0 &&
      materialCategoryList.length > 0 &&
      isEditMaterialTable?.length > 0 &&
      isMaterialIndex
    ) {
      const _list = [...isEditMaterialTable];
      _list.splice(isMaterialIndex, 1, {
        ..._list[isMaterialIndex],
        name: materialList[0]?.name,
        product_desc: "",
        material_code: materialList[0]?.material_code,
        material_category_id: materialCategoryList[0]?._id,
        hsn_code: materialCategoryList[0]?.hsn_code ? materialCategoryList[0]?.hsn_code : materialList[0]?.hsn_code,
        qty_type: materialList[0]?.qty_type,
        qty: isEditMaterialTable[0]?.qty,
        weight: materialList[0]?.weight,
        weight_type: materialList[0]?.weight_type,
        kot: materialList[0]?.kot,
        amount: isEditMaterialTable[0]?.amount,
      });
      setFormValue((s) => ({ ...s, lr_material_list: _list }));
    }
  }, [
    isOpen?.permission_at_item,
    materialList,
    materialCategoryList,
    isEditMaterialTable,
  ]);

  // edit lr table condition - end

  const totalCoutFunction = (name) => {
    if (formValue?.lr_material_list?.length > 0) {
      const total = formValue?.lr_material_list?.reduce((acc, currTeam) => {
        const value = Number(currTeam[name]);
        return acc + (isNaN(value) ? 0 : value);
      }, 0);

      return Number(total?.toFixed(2));
    }
    return 0;
  };

  const firstRowData = (_materialList, _materialCategoryList) => {
    return [{
      name: materialList[0]?.name,
      material_code: materialList[0]?.material_code,
      material_category_id: materialCategoryList[0]?._id,
      hsn_code: materialCategoryList[0]?.hsn_code ? materialCategoryList[0]?.hsn_code : materialList[0]?.hsn_code,
      qty_type: materialList[0]?.qty_type,
      qty: materialList[0]?.qty,
      weight: materialList[0]?.weight ? materialList[0]?.weight : 0,
      weight_type: materialList[0]?.weight_type,
      kot: materialList[0]?.kot ? materialList[0]?.kot : 0,
      amount: materialList[0]?.amount,
    }]
  }

  const getTodayDate = (date) => {
    if (date) {
      const today = new Date(date);
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
  }

  const getDetailsOfLrData = async () => {
    try {
      let object = {
        company_id: isOpen?.company_id ? isOpen?.company_id : StorageService.getCompanyId(),
        lr_id: isOpen?.lr_id,
      };
      const res = await getDataLrDetails(object);
      if (res?.responseCode === 200) {
        let values = res?.data?.lr;
        let dateVariable = (values?.eway_bill_date != null) ? values?.eway_bill_date : new Date();
        let tableData = (values?.lr_material_list?.length > 0) ? values?.lr_material_list : firstRowData(materialList, materialCategoryList);
        setFormValue({
          ...values,
          remarks: values?.remarks,
          eway_bill_number: values?.eway_bill_number,
          loading_slip_number: values?.sap_invoice_number,
          from_location: {
            label: `${values?.from_location}, ${values?.from_state}`,
            name: values?.from_location,
            _id: values?.from_location,
            stateName: values?.from_state
          },
          to_location: {
            label: `${values?.to_location}, ${values?.to_state}`,
            name: values?.to_location,
            _id: values?.to_location,
            stateName: values?.to_state
          },
          unit_id: values?.unit_id?._id,
          consignee_id: values?.consignee_id?._id,
          branch_id: {
            label: values?.branch_id?.branch,
            value: values?.branch_id?._id,
          },
          invoice_date: new Date(values?.invoice_date),
          eway_bill_date: new Date(dateVariable),
          eway_expiry_date: utils.parseUTCAsLocal(values?.eway_expiry_date),
          from_state: values?.from_state,
          to_state: values?.to_state,
          consignor_id: isOpen?._id ? isOpen?._id : values?.consignor_id?._id, // isOpen?._id,
          gst_invoice_number: values?.gst_number,
          freight_type: values?.lr_freight?.freight_type ?
            isOpen?.contract?.rate_type?.map((el) => {
              return {
                label: el?.name,
                value: el?.id,
              };
            })
              ?.find((el) => (el?.value === values?.lr_freight?.freight_type ? el : "")) :
            isOpen?.contract?.rate_type?.map((el) => {
              return {
                label: el?.name,
                value: el?.id,
              };
            })[0],
          total_qty: values?.lr_freight?.qty,
          rate: values?.lr_freight?.rate,
          total_amount: values?.lr_freight?.total_freight,
          lr_material_list: tableData,
          attachment_file: values?.attachment_file
        });
        setIsEditMaterialTable(tableData);
        setStartDate(new Date(values?.invoice_date));
        setEwayBillStartDate(new Date(dateVariable));
        setSelectUnitData({
          label: values?.unit_id?.name,
          value: values?.unit_id?._id,
        });
        setSelectConsigneeData({
          label: values?.consignee_id?.name,
          value: values?.consignee_id?._id,
        });
        setIsLrNumber(values?.lr_number);
        setIsLrStatus(values?.lr_status);
        setConsignorName(values?.consignor_id);
        if (values?.attachment_file?.length > 0) {
          setAttachments(values?.attachment_file);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!!isOpen?.isEditLr && !ewayCondition) {
      getDetailsOfLrData();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen?._id) {
      getDropdownDataBranchList();
    }
  }, [addNewBranch, isOpen]);

  useEffect(() => {
    handleOnChange("invoice_date", startDate);
  }, [startDate]);

  const handleTableIndexAction = (name, index) => {
    if (name === "material") {
      setShowAddItem(!showAddItem);
      setIsMaterialIndex(index);
    } else {
      setShowAddGroupItem({
        modalValue: true,
        nextView: false,
        previousView: true,
      });
      setIsMaterialIndex(index);
    }
  };

  const addNewItemHandler = (e, type) => {

    setOpenLoction(true)
    setTypeOfDropdown(type)
  }

  const callBackDataMap = async (data) => {
    if (typeOfDropdown == "from") {
      await onhandleSelect({ ...data, _id: data?.name, label: `${data?.name}, ${data?.stateName}` }, 'from_location')
    }
    if (typeOfDropdown == "to") {
      await onhandleSelect({ ...data, _id: data?.name, label: `${data?.name}, ${data?.stateName}` }, 'to_location')
    }

    fetchFromCity()

  }

  let gmapLocate = {
    isOpen: openLoction,
    closeModal: (e) => setOpenLoction(false),
    modalMainClass: "_dashCommon_Modal _mdModalLoction",
    modalTitle: 'Add Location',
    submitTitle: 'Add Location',
    callBackDataMap: callBackDataMap
  };

  const callBackAddressData = () => {
    setAddressId((s) => ({
      ...s,
      id: '',
      title: "address",
      view: false,
      isDetailsOnly: false,
    }))
  };

  const handleFileChange = async (event) => {
    const file = event?.target?.files[0];

    if (!file) return;

    if (file.type.startsWith("image/")) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", event?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [...attachments]
          fileArray.push(res?.data);
          setAttachments(fileArray);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        event.target.value = '';
      }
    } else {
      toast.error("Invalid file, choose images only");
      event.target.value = '';
    }
  }

  const documentRemove = async (path) => {
    setIsDelete(path);
  };

  const handleDeleteFileFunction = (path) => {
    let images = [...attachments];
    let newArray = images.filter((el) => el?.path != path)
    setAttachments(newArray)
  }

  const submitDeleteAttachement = async () => {
    setLoadingDelete(true);
    try {
      const payload = {
        file_path: isDelete
      }

      const res = await deleteImage(payload)
      if (res?.responseCode === 200) {
        setLoadingDelete(false);
        handleDeleteFileFunction(isDelete);
        toast.success(res?.responseMessage)
        setIsDelete(false)
      } else {
        setIsDelete(false)
        setLoadingDelete(false);
        toast.error(res?.responseMessage)
      }
    } catch (error) {
      setLoadingDelete(false)
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteAttachement,
    isLoadding: loadingDelete,
  }

  let storeModelProps = {
    isOpen: imagePreview,
    modalMainClass: '_dashCommon_Modal _mdModal',
    modalTitle: 'Preview',
    submitTitle: 'Preview',
    footerPart: true,
    hideFooterSumbmitBtn: true,
    hideCompletelyFoolter: true,
    modalZIndex: 999999,
    closeModal: (e) => setImagePreview(false),
  }

  const handleFetchEwayBillFunction = async () => {
    setEwayBillLoading(true);
    try {
      let object = {
        branch_id: formValue?.branch_id?.value ? formValue?.branch_id?.value : '',
        company_id: StorageService.getCompanyId(),
        ewbNo: formValue?.eway_bill_number ? formValue?.eway_bill_number?.toString() : null,
      }
      const ewayBillResponse = await getEwayBillLrData(object);
      if (ewayBillResponse?.responseCode == 200) {
        setLrModalToggleForEway({ ewayModal: true, eway_bill: ewayBillResponse?.data });
        setEwayBillLrData({ ...formValue, ewayFetch: true });
        setEwayBillLoading(false);
      } else {
        if (ewayBillResponse?.responseMessage) {
          toast.error(`${ewayBillResponse?.responseMessage}`);
        }
        setEwayBillLoading(false);
      }
    } catch (error) {
      setEwayBillLoading(false);
    }
  }

  const handlePermissionCall = async (e) => {
    e.preventDefault();

    await actionPermission({
      company_id: StorageService.getCompanyId(),
      type: constant?.USABILITY_CONFIG_TYPES?.EWAY_FETCH,
      onSuccess: () => handleFetchEwayBillFunction(),
      setModalConfig,
    });
  };

  useEffect(() => {
    if (ewayCondition) {
      const newMaterialList = (isOpen?.eway_bill && isOpen?.eway_bill?.material_list?.length > 0) ? isOpen?.eway_bill?.material_list.map(el => ({
        name: el?.name,
        product_desc: el?.product_desc,
        material_code: el?.material_code,
        material_category_id: el?.material_category_id,
        qty_type: +el?.qty_type,
        weight_type: el?.weight_type,
        amount: el?.amount,
        hsn_code: el?.hsn_code ? el?.hsn_code : null,
        kot: el?.kot != null ? el?.kot : 0,
        qty: el?.qty != null ? el?.qty : 0,
        weight: el?.weight != null ? el?.weight : 0,
      })) : [];

      let values = isOpen?.eway_bill;
      let values1 = isOpen?.eway_bill?.ewb_details;
      let transDocNumber = (isOpen?.eway_bill &&
        isOpen?.eway_bill?.ewb_details &&
        isOpen?.eway_bill?.ewb_details?.VehiclListDetails[0] &&
        isOpen?.eway_bill?.ewb_details?.VehiclListDetails[0]?.transDocNo) ? isOpen?.eway_bill?.ewb_details?.VehiclListDetails[0]?.transDocNo : '';
      const dateVariable = values1?.ewayBillDate ? utils.parseCustomDate(values1?.ewayBillDate) : new Date();
      const dateVariableEndDate = values1?.validUpto ? utils.parseCustomDate(values1?.validUpto) : new Date();
      let tableData = (newMaterialList?.length > 0) ? newMaterialList : firstRowData(materialList, materialCategoryList);
      setFormValue((s) => ({
        ...s,
        from_location: values?.from_location?.city?.label ? {
          label: `${values?.from_location?.city?.label}, ${values?.from_location?.state?.label}`,
          name: values?.from_location?.city?.label,
          _id: values?.from_location?._id,
          stateName: values?.from_location?.state?.label
        } : {},
        to_location: values?.to_location?.city?.label ? {
          label: `${values?.to_location?.city?.label}, ${values?.to_location?.state?.label}`,
          name: values?.to_location?.city?.label,
          _id: values?.to_location?._id,
          stateName: values?.to_location?.state?.label
        } : {},
        unit_id: values?.from_location?._id ? values?.from_location?._id : '',
        consignee_id: values?.to_location?._id ? values?.to_location?._id : '',
        branch_id: ewayBillLrData?.branch_id,
        invoice_date: new Date(),
        eway_bill_number: values1?.ewbNo ? +values1?.ewbNo : null,
        eway_bill_date: dateVariable,
        eway_expiry_date: utils.parseUTCAsLocal(dateVariableEndDate),
        from_state: values?.from_location?.state?.label ? values?.from_location?.state?.label : '',
        to_state: values?.to_location?.state?.label ? values?.to_location?.state?.label : '',
        consignor_id: isOpen?._id,
        gst_invoice_number: '',
        mlr_number: transDocNumber ? transDocNumber : '',
        freight_type: values?.lr_freight?.freight_type ?
          isOpen?.contract?.rate_type?.map((el) => {
            return {
              label: el?.name,
              value: el?.id,
            };
          })
            ?.find((el) => (el?.value === values?.lr_freight?.freight_type ? el : "")) :
          isOpen?.contract?.rate_type?.map((el) => {
            return {
              label: el?.name,
              value: el?.id,
            };
          })[0],
        total_qty: values1?.lr_freight?.qty,
        rate: values1?.lr_freight?.rate,
        total_amount: values1?.lr_freight?.total_freight,
        lr_material_list: tableData,
        invoice_number: values1?.docNo ? values1?.docNo : ''
      }));
      setEwayBillRadioToggle(true);
      setIsEditMaterialTable(tableData);
      setStartDate(new Date());
      setEwayBillStartDate(dateVariable);
      setSelectUnitData({
        label: values?.from_location?.city?.label,
        value: values?.from_location?._id,
        name: `${values?.from_location?.code} ${values?.from_location?.name}`,
        code: values?.from_location?.code,
        city: values?.from_location?.city,
        state: values?.from_location?.state,
        pincode: values?.from_location?.pincode ? values?.from_location?.pincode : '',
      });
      setSelectConsigneeData({
        label: values?.to_location?.city?.label,
        value: values?.to_location?._id,
        name: `${values?.to_location?.code} ${values?.to_location?.name}`,
        code: values?.to_location?.code,
        city: values?.to_location?.city,
        state: values?.to_location?.state,
        pincode: values?.to_location?.pincode ? values?.to_location?.pincode : '',
      });
      setIsLrNumber(values?.lr_number);
      setIsLrStatus(values?.lr_status);
      setConsignorName(isOpen?._id);
      if (values?.attachment_file?.length > 0) {
        setAttachments(values?.attachment_file);
      }
    }
  }, [ewayCondition])

  let ebillExpProps = {
    isOpen: modalConfig.isOpen,
    closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
    onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
    modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
    headerPart: true,
    floatCrossBtn: true,
    submitTitle: "Send Enquiry",
    messageType: modalConfig.messageType,
    templateId: modalConfig.templateId,
    templateData: modalConfig.templateData
  };

  const youtubeProps = {
    isOpen: youtubeVideos,
    closeModal: () => setYoutubeVideos((s) => ({ ...s, moduleName: '', moduleAction: false })),
    headerPart: false,
    modalTitle: `Add LR`,
    submitTitle: `Add LR`,
    modalMainClass: "_mdModal",
    videosModuleName: 'LR Creation'
  }

  return (
    <>
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {" "}
          {!!isOpen?.isEditLr ? "Edit LR" : "Add LR"}{" "} &nbsp; {isOpen?.contract?.name && <span className="default_lrContrx"> {isOpen?.contract?.name} </span>}
        </h5>
        <div className="flxs_lr_cls">
          {!isOpen?.isEditLr && (
            <div className="youtube_Icon" onClick={(e) => setYoutubeVideos((s) => ({ ...s, moduleName: 'lr_creation', moduleAction: true }))}>
              <button><FaYoutube size={36} /></button>
            </div>
          )}
          <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => (onClose(!isOpen), setEwayBillLrData({}))}>
            <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path
                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                fill="black" />
            </svg>
          </CrossButton>
        </div>
      </div>

      <div className="offcanvas-body __addNewLrBody">
        <div className="pr_addNewLrBx">
          <div className="pr_procssBx" style={{ marginBottom: "9px" }}>
            <div className="_lrdMax" style={{ maxWidth: '100%', paddingRight: '30px' }}>
              <div className="flxInr">
                <div className="halfDiv">
                  <CommonDatePicker
                    name="invoice_date"
                    label="LR Date & Time * "
                    id={Math.random() * 100000}
                    maxDate={new Date()}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    error={!!(typeof formError === "object") ? formError?.invoice_date : ""}
                  />
                </div>

                <div className="halfDiv">
                  <CommonInput
                    disabled={!!isOpen?.isEditLr ? true : false}
                    type="text"
                    label="LR Number "
                    placeholder="LR Number "
                    name="lr_number"
                    value={isLrNumber ? isLrNumber : formValue.lr_number}
                    onClick={handleLrFunctionality}
                  />
                </div>

                <div className="halfDiv">
                  <CommonInput
                    type="text"
                    label="Party Name *"
                    placeholder="Party Name *"
                    name="name"
                    value={isOpen?.name ? isOpen?.name : consignorName?.name}
                    disabled
                  />
                </div>

                <div className="halfDiv">
                  <CustomSelect
                    flotingLabel="Branch Name*"
                    disabled={(isLrStatus > 1 && !!isOpen?.isEditLr) ? true : (ewayBillLrData?.ewayFetch ? true : false)}
                    options={dropdownBranchList?.map((el) => {
                      return {
                        label: el?.branch,
                        value: el?._id,
                      };
                    })}
                    name="branch_id"
                    label="Branch Name"
                    isAddButton={masterChildBranch?.create === 1 ? true : false}
                    addButtonAction={(e) => setAddNewBranch(!addNewBranch)}
                    placeholder="Branch Name"
                    value={formValue?.branch_id}
                    error={formError["branch_id.label"]}
                    onSelect={(data) => onhandleSelect(data, "branch_id")}
                  />
                </div>

                <div className="halfDiv">
                  <CityDropdownForTrip
                    label="From Station * "
                    placeholder="Select a city"
                    fetchData={fetchFromCity}
                    selectedItem={formValue?.from_location}
                    onChange={(data) => onhandleSelect(data, 'from_location')}
                    error={!!formError["from_location.name"]}
                    errorMessage={formError["from_location.name"]}
                    isAddButton={true}
                    addButtonAction={(e) => addNewItemHandler(e, "from")}
                    pageSize={20}
                    disabled={dataSingleUnit?.city?.label}
                  />
                </div>

                <div className="halfDiv">
                  <CityDropdownForTrip
                    label="To Station * "
                    placeholder="Select a city"
                    fetchData={fetchFromCity}
                    selectedItem={formValue?.to_location}
                    onChange={(data) => onhandleSelect(data, 'to_location')}
                    error={!!formError["to_location.name"]}
                    errorMessage={formError["to_location.name"]}
                    isAddButton={true}
                    addButtonAction={(e) => addNewItemHandler(e, "to")}
                    pageSize={20}
                    disabled={dataSingleConsignee?.city?.label}
                  />
                </div>
              </div>

              <div className="_csgAdd_bx mt-3">
                <div className="halfDiv">
                  {selectUnitData?.value ? (
                    <div className="_unit_detailBxs _avPointer">
                      <div className='flex_extand_avt'>
                        <span className='extand_address_name'> Unit </span>
                        <button
                          className='view_btn_extand'
                          onClick={() => {
                            setAddressId({
                              ...addressId,
                              id: selectUnitData?.value,
                              title: "address",
                              view: true,
                              isDetailsOnly: true,
                            });
                            setShowOffcanvas(true);
                          }}
                        >
                          View
                        </button>
                      </div>
                      <p> Name : {selectUnitData?.label} </p>
                      <p> Code : {dataSingleUnit?.code} </p>
                      <p>
                        {" "}
                        Address :{" "}
                        {dataSingleUnit?.address_line1
                          ? dataSingleUnit?.address_line1
                          : "-"}{" "}
                        {dataSingleUnit?.city?.label
                          ? dataSingleUnit?.city?.label
                          : "-"}{" "}
                        {dataSingleUnit?.state?.label
                          ? dataSingleUnit?.state?.label
                          : "-"}{" "}
                      </p>
                      <p> Pin Code : {dataSingleUnit?.pincode ? dataSingleUnit?.pincode : '-'} </p>
                      <div className="_addDel_bx mt-3">
                        <button
                          className="_pickN_dropBtn"
                          onClick={(e) =>
                            setUnitInLR({ _id: selectUnitData?.value })
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                              fill="#1956F6"
                            />
                          </svg>
                          <span>Add New</span>
                        </button>

                        <button
                          className="_deleteBtn"
                          onClick={(e) => {
                            setSelectUnitData(null);
                            setDataSingleUnit(null)
                            handleOnChange("unit_id", "");
                            onhandleSelect({}, 'from_location')
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M2.83333 17C2.31389 17 1.86937 16.8152 1.49978 16.4456C1.13019 16.076 0.945074 15.6312 0.944444 15.1111V2.83333H0V0.944444H4.72222V0H10.3889V0.944444H15.1111V2.83333H14.1667V15.1111C14.1667 15.6306 13.9819 16.0754 13.6123 16.4456C13.2427 16.8158 12.7979 17.0006 12.2778 17H2.83333ZM12.2778 2.83333H2.83333V15.1111H12.2778V2.83333ZM4.72222 13.2222H6.61111V4.72222H4.72222V13.2222ZM8.5 13.2222H10.3889V4.72222H8.5V13.2222Z"
                              fill="#C41F1F"
                            ></path>
                          </svg>
                          <span>Remove</span>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      className="addConsignee_lBtn"
                      onClick={(e) => setUnitInLR(!unitInLR)}
                    >
                      {" "}
                      + Add Unit{" "}
                    </button>
                  )}
                  {formError?.unit_id && (
                    <span className="input_drop_error">{formError?.unit_id}</span>
                  )}
                </div>

                <div className="halfDiv">
                  {selectConsigneeData?.value ? (
                    <div className="_unit_detailBxs">
                      <div className='flex_extand_avt'>
                        <span className='extand_address_name'> Consignee </span>
                        <button
                          className='view_btn_extand'
                          onClick={() => {
                            setAddressId({
                              ...addressId,
                              id: selectConsigneeData?.value,
                              title: "address",
                              view: true,
                              isDetailsOnly: true,
                            });
                            setShowOffcanvas(true);
                          }}
                        >
                          View
                        </button>
                      </div>
                      <p> Name : {selectConsigneeData?.label} </p>
                      <p>
                        {" "}
                        Code : {
                          dataSingleConsignee?.code
                        }{" "}
                      </p>
                      <p>
                        {" "}
                        Address :{" "}
                        {dataSingleConsignee?.address_line1
                          ? dataSingleConsignee?.address_line1
                          : "-"}{" "}
                        {dataSingleConsignee?.city?.label
                          ? dataSingleConsignee?.city?.label
                          : "-"}{" "}
                        {dataSingleConsignee?.state?.label
                          ? dataSingleConsignee?.state?.label
                          : "-"}{" "}
                      </p>
                      <p> Pin Code : {dataSingleConsignee?.pincode ? dataSingleConsignee?.pincode : '-'} </p>
                      <div className="_addDel_bx mt-3">
                        <button
                          className="_pickN_dropBtn"
                          onClick={(e) =>
                            setConsigneeInLR({ _id: selectConsigneeData?.value })
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                              fill="#1956F6"
                            />
                          </svg>
                          <span>Add New</span>
                        </button>

                        <button
                          className="_deleteBtn"
                          onClick={(e) => {
                            setSelectConsigneeData(null);
                            setDataSingleConsignee({})
                            handleOnChange("consignee_id", "");
                            onhandleSelect({}, 'to_location')
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M2.83333 17C2.31389 17 1.86937 16.8152 1.49978 16.4456C1.13019 16.076 0.945074 15.6312 0.944444 15.1111V2.83333H0V0.944444H4.72222V0H10.3889V0.944444H15.1111V2.83333H14.1667V15.1111C14.1667 15.6306 13.9819 16.0754 13.6123 16.4456C13.2427 16.8158 12.7979 17.0006 12.2778 17H2.83333ZM12.2778 2.83333H2.83333V15.1111H12.2778V2.83333ZM4.72222 13.2222H6.61111V4.72222H4.72222V13.2222ZM8.5 13.2222H10.3889V4.72222H8.5V13.2222Z"
                              fill="#C41F1F"
                            ></path>
                          </svg>
                          <span>Remove</span>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      className="addConsignee_lBtn"
                      onClick={(e) => setConsigneeInLR(!consigneeInLR)}
                    >
                      + Add Consignee
                    </button>
                  )}
                  {formError?.consignee_id && (
                    <span className="input_drop_error">
                      {formError?.consignee_id}
                    </span>
                  )}
                </div>
              </div>


            </div>
          </div>

          {(isOpen?.permission_at_item_parent && (isOpen?.permission_at_item?.item?.view === 1 ||
            isOpen?.permission_at_item?.item_desc?.view === 1 ||
            isOpen?.permission_at_item?.item_group_hsn?.view === 1 ||
            isOpen?.permission_at_item?.kot?.view === 1 ||
            isOpen?.permission_at_item?.qty?.view === 1 ||
            isOpen?.permission_at_item?.sales?.view === 1 ||
            isOpen?.permission_at_item?.weight?.view === 1)) ? (
            <div className="pr_procssBx" style={{ marginBottom: "9px", marginTop: '30px' }}>
              <div className="_materialTable">
                <table>
                  <thead>
                    <tr>
                      {isOpen?.permission_at_item?.item_desc?.view === 1 ? <th style={{ width: '16%' }}> Description </th> : <></>}
                      {isOpen?.permission_at_item?.item?.view === 1 ? <th style={{ width: '12%' }}> Material </th> : <></>}
                      {isOpen?.permission_at_item?.item_group_hsn?.view === 1 ? <th style={{ width: '12%' }}>Material Category</th> : <></>}
                      {isOpen?.permission_at_item?.item_group_hsn?.view === 1 ? <th style={{ width: '9%' }}>HSN Code</th> : <></>}
                      {isOpen?.permission_at_item?.qty?.view === 1 ? <th style={{ width: '5%' }}>QTY</th> : <></>}
                      {isOpen?.permission_at_item?.weight?.view === 1 ? <th style={{ width: '5%' }}>Weight</th> : <></>}
                      {isOpen?.permission_at_item?.kot?.view === 1 ? <th style={{ width: '7%' }}>KOT</th> : <></>}
                      {isOpen?.permission_at_item?.sales?.view === 1 ? <th style={{ width: '10%' }}>Amount (₹)</th> : <></>}
                      <th style={{ width: '0%', padding: '0px' }}></th>
                    </tr>
                  </thead>

                  <tbody>
                    {formValue?.lr_material_list?.length > 0 ? (
                      formValue?.lr_material_list?.map((el, ind) => {
                        return (
                          <React.Fragment key={ind}>
                            <tr className="__mtrTr_bxs" key={ind + el?.name}>
                              {isOpen?.permission_at_item?.item_desc?.view === 1 ?
                                <td>
                                  <CommonInput
                                    type="text"
                                    placeholder="Description"
                                    name="product_desc"
                                    maxLength="100"
                                    onInput={maxLengthCheck}
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    value={el?.product_desc}
                                    focus={
                                      !!formError[`lr_material_list[${ind}].product_desc`]
                                    }
                                    error={
                                      formError[`lr_material_list[${ind}].product_desc`]
                                    }
                                    onChange={(e) => handleInputChange(e, ind)}
                                  />
                                </td>
                                :
                                <></>
                              }
                              {isOpen?.permission_at_item?.item?.view === 1 ?
                                <td>
                                  <CustomSelect
                                    placeholder="Material * "
                                    options={
                                      materialList?.length > 0
                                        ? materialList?.map((el) => {
                                          return {
                                            ...el,
                                            label: el?.name,
                                            value: el?._id,
                                          };
                                        })
                                        : []
                                    }
                                    value={
                                      materialList
                                        ?.map((el) => {
                                          return {
                                            label: el?.name,
                                            value: el?._id,
                                          };
                                        })
                                        ?.filter((item) =>
                                          item?.label === el?.name ? item : ""
                                        )[0]
                                    }
                                    name="name"
                                    isAddButton={true}
                                    addButtonAction={(e) =>
                                      handleTableIndexAction("material", ind)
                                    }
                                    error={
                                      formError[`lr_material_list[${ind}].name`]
                                    }
                                    onSelect={(data) =>
                                      handleInputChangeSelect1(data, "name", ind)
                                    }
                                  />
                                </td>
                                :
                                <></>
                              }
                              {isOpen?.permission_at_item?.item_group_hsn?.view === 1 ?
                                <td>
                                  <CustomSelect
                                    placeholder="Category * "
                                    value={
                                      materialCategoryList
                                        ?.map((el) => {
                                          return {
                                            label: el?.name,
                                            value: el?._id,
                                          };
                                        })
                                        ?.filter((item) =>
                                          item?.value === el?.material_category_id
                                            ? item
                                            : ""
                                        )[0]
                                    }
                                    options={
                                      materialCategoryList?.length > 0
                                        ? materialCategoryList?.map((el) => {
                                          return {
                                            ...el,
                                            label: el?.name,
                                            value: el?._id,
                                          };
                                        })
                                        : []
                                    }
                                    name="material_category_id"
                                    isAddButton={true}
                                    addButtonAction={(e) =>
                                      handleTableIndexAction(
                                        "material_category",
                                        ind
                                      )
                                    }
                                    error={
                                      formError[
                                      `lr_material_list[${ind}].material_category_id`
                                      ]
                                    }
                                    onSelect={(data) =>
                                      handleInputChangeSelect2(
                                        data,
                                        "material_category_id",
                                        ind
                                      )
                                    }
                                  />
                                </td>
                                :
                                <></>
                              }
                              {isOpen?.permission_at_item?.item_group_hsn?.view === 1 ?
                                <td>
                                  <CommonInput
                                    type="number"
                                    placeholder="HSN"
                                    name="hsn_code"
                                    maxLength="6"
                                    onInput={maxLengthCheck}
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    value={el?.hsn_code}
                                    focus={
                                      !!formError[
                                      `lr_material_list[${ind}].hsn_code`
                                      ]
                                    }
                                    error={
                                      formError[`lr_material_list[${ind}].hsn_code`]
                                    }
                                    onChange={(e) => handleInputChange(e, ind)}
                                    onKeyDown={(e) => lrHandleKeyDown(e, 'amount')}
                                  />
                                </td>
                                :
                                <></>
                              }
                              {isOpen?.permission_at_item?.qty?.view === 1 ? <td>
                                <div className="_inpSelect llt_weight_input">
                                  <CommonInput
                                    type="number"
                                    placeholder="Qty "
                                    name="qty"
                                    maxLength="8"
                                    onInput={maxLengthCheck}
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    value={el?.qty > 0 ? el?.qty : ''}
                                    focus={
                                      !!formError[`lr_material_list[${ind}].qty`]
                                    }
                                    error={
                                      formError[`lr_material_list[${ind}].qty`]
                                    }
                                    onChange={(e) => handleInputChange(e, ind)}
                                    onKeyDown={(e) => lrHandleKeyDown(e, 'qty')}
                                  />

                                  <select
                                    className="_selectInner_bx llt_qty_input"
                                    name="qty_type"
                                    id="qty_type"
                                    defaultValue={el?.qty_type}
                                    onChange={(e) => handleInputChange(e, ind)}
                                  >
                                    {masterData?.material_qty_type_list?.map(
                                      (el, indx) => {
                                        return (
                                          <option
                                            key={indx}
                                            value={el?.id}
                                            defaultValue={ind === 0}
                                          >
                                            {el?.name}
                                          </option>
                                        );
                                      }
                                    )}
                                  </select>
                                </div>
                              </td> : <></>}
                              {isOpen?.permission_at_item?.weight?.view === 1 ? <td>
                                <div className="_inpSelect llt_weight_input">
                                  <CommonInput
                                    type="number"
                                    placeholder="Wgt "
                                    name="weight"
                                    maxLength="8"
                                    onInput={maxLengthCheck}
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    value={el?.weight > 0 ? el?.weight : ''}
                                    focus={
                                      !!formError[
                                      `lr_material_list[${ind}].weight`
                                      ]
                                    }
                                    error={
                                      formError[`lr_material_list[${ind}].weight`]
                                    }
                                    onChange={(e) => handleInputChange(e, ind)}
                                    onKeyDown={(e) => lrHandleKeyDown(e, 'weight')}
                                  />
                                  <select
                                    className="_selectInner_bx llt_qty_input"
                                    name="weight_type"
                                    id="weight_type"
                                    disabled
                                    defaultValue={el?.weight_type}
                                    onChange={(e) => handleInputChange(e, ind)}
                                  >
                                    {masterData?.material_weight_type_list?.map(
                                      (el, indxx) => {
                                        return (
                                          <option
                                            key={indxx}
                                            value={el?.id}
                                            defaultValue={ind === 0}
                                          >
                                            {el?.name}
                                          </option>
                                        );
                                      }
                                    )}
                                  </select>
                                </div>
                              </td> : <></>}
                              {isOpen?.permission_at_item?.kot?.view === 1 ? <td>
                                <CommonInput
                                  type="number"
                                  placeholder="KOT "
                                  name="kot"
                                  maxLength="8"
                                  onInput={maxLengthCheck}
                                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                  value={el?.kot > 0 ? el?.kot : ''}
                                  focus={
                                    !!formError[`lr_material_list[${ind}].kot`]
                                  }
                                  error={
                                    formError[`lr_material_list[${ind}].kot`]
                                  }
                                  onChange={(e) => handleInputChange(e, ind)}
                                  onKeyDown={(e) => lrHandleKeyDown(e, 'kot')}
                                />
                              </td> : <></>}
                              {isOpen?.permission_at_item?.sales?.view === 1 ?
                                <td>
                                  <CommonInput
                                    type="number"
                                    placeholder="Amount (₹)"
                                    name="amount"
                                    maxLength="10"
                                    onInput={maxLengthCheck}
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    value={el?.amount > 0 ? el?.amount : ''}
                                    focus={
                                      !!formError[`lr_material_list[${ind}].amount`]
                                    }
                                    error={
                                      formError[`lr_material_list[${ind}].amount`]
                                    }
                                    onChange={(e) => handleInputChange(e, ind)}
                                    onKeyDown={(e) => lrHandleKeyDown(e, 'amount')}
                                  />
                                </td> : <></>}
                              <td style={{ padding: formValue?.lr_material_list?.length !== 1 ? '12px 5px 8px' : '0px', borderLeft: formValue?.lr_material_list?.length !== 1 ? '1px solid var(--light-gray)' : '0px' }}>
                                {formValue?.lr_material_list?.length !== 1 && (
                                  <p
                                    onClick={(e) => handleRemoveClick(e, ind)}
                                    className="faTrash_cls"
                                  >
                                    {" "}
                                    <FaTrash />{" "}
                                  </p>
                                )}
                              </td>
                            </tr>
                            {formValue?.lr_material_list?.length - 1 === ind && (
                              <tr style={{ position: 'relative' }}>

                                {isOpen?.permission_at_item?.item_desc?.view === 1 ? <td></td> : <></>}
                                {isOpen?.permission_at_item?.item?.view === 1 ? <td></td> : <></>}
                                {isOpen?.permission_at_item?.item_group_hsn?.view === 1 ? <td></td> : <></>}
                                {isOpen?.permission_at_item?.item_group_hsn?.view === 1 ? <td></td> : <></>}
                                {isOpen?.permission_at_item?.qty?.view === 1 ?
                                  <td align="right">
                                    {totalCoutFunction("qty")} Qty{" "}
                                  </td> : <></>}

                                {isOpen?.permission_at_item?.weight?.view === 1 ?
                                  <td align="right">
                                    {totalCoutFunction("weight") > 0 ? (totalCoutFunction("weight") / 1000)?.toFixed(2) : 0} {isOpen?.permission_at_item?.total_weight_type ? masterData.material_weight_type[isOpen?.permission_at_item?.total_weight_type] : 'TON'}{" "}
                                  </td> : <></>}

                                {isOpen?.permission_at_item?.kot?.view === 1 ?
                                  <td align="right">
                                    {" "}
                                    {totalCoutFunction("kot")} kot{" "}
                                  </td>
                                  : <></>}
                                {isOpen?.permission_at_item?.sales?.view === 1 ?
                                  <td align="right">
                                    {" "}
                                    {totalCoutFunction("amount")} ₹{" "}
                                  </td>
                                  : <></>}
                                <td style={{ padding: '0px' }}>
                                  <div style={{ minHeight: '20px' }}>
                                    <button className="addMst_btn" style={{ position: 'absolute', left: '18px', top: '6px' }} onClick={(e) => addNewTableRowHandler(e)} >
                                      + Add Material
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ) : <></>}

          {isOpen?.permission_at_invoice_number?.view === 1 ||
            isOpen?.permission_at_field2?.view === 1 ||
            isOpen?.permission_at_field3?.view === 1 ||
            isOpen?.permission_at_field4?.view === 1 ||
            isOpen?.permission_at_field5?.view === 1 ? (
            <div className="pr_procssBx __docPrx_bx" style={{ marginBottom: "20px", marginRight: '30px' }}>
              <div className="_inrPrt_flx2 ">
                <div className="singleDiv">
                  <p>Document Details</p>
                </div>

                {isOpen?.permission_at_invoice_number?.view === 1 && (
                  <div className="halfDiv">
                    <CommonInput
                      type={isOpen?.permission_at_invoice_number?.field_type === 2 ? "number" : "text"}
                      label={
                        isOpen?.permission_at_invoice_number?.mandatory === 1
                          ? "Invoice Number * "
                          : "Invoice Number"
                      }
                      placeholder={
                        isOpen?.permission_at_invoice_number?.mandatory === 1
                          ? "Invoice Number * "
                          : "Invoice Number"
                      }
                      name="invoice_number"
                      min={isOpen?.permission_at_invoice_number?.min ? isOpen?.permission_at_invoice_number?.min : ""}
                      max={isOpen?.permission_at_invoice_number?.max ? isOpen?.permission_at_invoice_number?.max : ""}
                      maxLength={
                        isOpen?.permission_at_invoice_number?.max
                          ? isOpen?.permission_at_invoice_number?.max
                          : "12"
                      }
                      onInput={maxLengthCheck}
                      value={formValue.invoice_number}
                      focus={
                        !!(
                          typeof formError === "object" &&
                          formError?.invoice_number
                        )
                      }
                      error={
                        !!(typeof formError === "object")
                          ? formError?.invoice_number
                          : ""
                      }
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                    />
                    <span className="outOf_cks"> {formValue?.invoice_number?.toString()?.length} / {isOpen?.permission_at_invoice_number?.max ? isOpen?.permission_at_invoice_number?.max : 12} </span>
                  </div>
                )}

                {isOpen?.permission_at_field2?.view === 1 && (
                  <div className="halfDiv">
                    <CommonInput
                      type={isOpen?.permission_at_field2?.field_type === 2 ? "number" : "text"}
                      label={
                        isOpen?.permission_at_field2?.mandatory === 1
                          ? isOpen?.permission_at_field2?.field_name
                            ? `${isOpen?.permission_at_field2?.field_name} *`
                            : "SAP Invoice Number * "
                          : isOpen?.permission_at_field2?.field_name
                            ? `${isOpen?.permission_at_field2?.field_name}`
                            : "SAP Invoice Number "
                      }
                      placeholder={
                        isOpen?.permission_at_field2?.mandatory === 1
                          ? isOpen?.permission_at_field2?.field_name
                            ? `${isOpen?.permission_at_field2?.field_name} *`
                            : "SAP Invoice Number * "
                          : isOpen?.permission_at_field2?.field_name
                            ? `${isOpen?.permission_at_field2?.field_name}`
                            : "SAP Invoice Number "
                      }
                      min={isOpen?.permission_at_field2?.min ? isOpen?.permission_at_field2?.min : ""}
                      max={isOpen?.permission_at_field2?.max ? isOpen?.permission_at_field2?.max : ""}
                      maxLength={
                        isOpen?.permission_at_field2?.max
                          ? isOpen?.permission_at_field2?.max
                          : "12"
                      }
                      onInput={maxLengthCheck}
                      name="loading_slip_number"
                      value={formValue.loading_slip_number}
                      focus={
                        !!(
                          typeof formError === "object" &&
                          formError?.loading_slip_number
                        )
                      }
                      error={
                        !!(typeof formError === "object")
                          ? formError?.loading_slip_number
                          : ""
                      }
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                    />
                    <span className="outOf_cks"> {formValue?.loading_slip_number?.toString()?.length} / {isOpen?.permission_at_field2?.max ? isOpen?.permission_at_field2?.max : 12} </span>
                  </div>
                )}

                {isOpen?.permission_at_field3?.view === 1 && (
                  <div className="halfDiv">
                    <CommonInput
                      type={isOpen?.permission_at_field3?.field_type === 2 ? "number" : "text"}
                      label={
                        isOpen?.permission_at_field3?.mandatory === 1
                          ? isOpen?.permission_at_field3?.field_name
                            ? `${isOpen?.permission_at_field3?.field_name} *`
                            : "GST Number *"
                          : isOpen?.permission_at_field3?.field_name
                            ? `${isOpen?.permission_at_field3?.field_name}`
                            : "GST Number "
                      }
                      placeholder={
                        isOpen?.permission_at_field3?.mandatory === 1
                          ? isOpen?.permission_at_field3?.field_name
                            ? `${isOpen?.permission_at_field3?.field_name} *`
                            : "GST Number *"
                          : isOpen?.permission_at_field3?.field_name
                            ? `${isOpen?.permission_at_field3?.field_name}`
                            : "GST Number "
                      }
                      min={isOpen?.permission_at_field3?.min ? isOpen?.permission_at_field3?.min : ""}
                      max={isOpen?.permission_at_field3?.max ? isOpen?.permission_at_field3?.max : ""}
                      maxLength={
                        isOpen?.permission_at_field3?.max
                          ? isOpen?.permission_at_field3?.max
                          : "12"
                      }
                      onInput={maxLengthCheck}
                      name="gst_invoice_number"
                      value={formValue.gst_invoice_number}
                      focus={
                        !!(
                          typeof formError === "object" &&
                          formError?.gst_invoice_number
                        )
                      }
                      error={
                        !!(typeof formError === "object")
                          ? formError?.gst_invoice_number
                          : ""
                      }
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                    />
                    <span className="outOf_cks"> {formValue?.gst_invoice_number?.toString()?.length} / {isOpen?.permission_at_field3?.max ? isOpen?.permission_at_field3?.max : 12} </span>
                  </div>
                )}

                {isOpen?.permission_at_field4?.view === 1 && (
                  <div className="halfDiv">
                    <CommonInput
                      type={isOpen?.permission_at_field4?.field_type === 2 ? "number" : "text"}
                      label={
                        isOpen?.permission_at_field4?.mandatory === 1
                          ? isOpen?.permission_at_field4?.field_name
                            ? `${isOpen?.permission_at_field4?.field_name} *`
                            : "PO Number *"
                          : isOpen?.permission_at_field4?.field_name
                            ? `${isOpen?.permission_at_field4?.field_name}`
                            : "PO Number "
                      }
                      placeholder={
                        isOpen?.permission_at_field4?.mandatory === 1
                          ? isOpen?.permission_at_field4?.field_name
                            ? `${isOpen?.permission_at_field4?.field_name} *`
                            : "PO Number *"
                          : isOpen?.permission_at_field4?.field_name
                            ? `${isOpen?.permission_at_field4?.field_name}`
                            : "PO Number "
                      }
                      min={isOpen?.permission_at_field4?.min ? isOpen?.permission_at_field4?.min : ""}
                      max={isOpen?.permission_at_field4?.max ? isOpen?.permission_at_field4?.max : ""}
                      maxLength={
                        isOpen?.permission_at_field4?.max
                          ? isOpen?.permission_at_field4?.max
                          : "12"
                      }
                      onInput={maxLengthCheck}
                      name="po_number"
                      value={formValue.po_number}
                      focus={
                        !!(typeof formError === "object" && formError?.po_number)
                      }
                      error={
                        !!(typeof formError === "object")
                          ? formError?.po_number
                          : ""
                      }
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                    />
                    <span className="outOf_cks"> {formValue?.po_number?.toString()?.length} / {isOpen?.permission_at_field4?.max ? isOpen?.permission_at_field4?.max : 12} </span>
                  </div>
                )}

                {isOpen?.permission_at_field5?.view === 1 && (
                  <div className="halfDiv">
                    <CommonInput
                      type={isOpen?.permission_at_field5?.field_type === 2 ? "number" : "text"}
                      label={
                        isOpen?.permission_at_field5?.mandatory === 1
                          ? isOpen?.permission_at_field5?.field_name
                            ? `${isOpen?.permission_at_field5?.field_name} *`
                            : "MLR Number *"
                          : isOpen?.permission_at_field5?.field_name
                            ? `${isOpen?.permission_at_field5?.field_name}`
                            : "MLR Number "
                      }
                      placeholder={
                        isOpen?.permission_at_field5?.mandatory === 1
                          ? isOpen?.permission_at_field5?.field_name
                            ? `${isOpen?.permission_at_field5?.field_name} *`
                            : "MLR Number *"
                          : isOpen?.permission_at_field5?.field_name
                            ? `${isOpen?.permission_at_field5?.field_name}`
                            : "MLR Number "
                      }
                      min={isOpen?.permission_at_field5?.min ? isOpen?.permission_at_field5?.min : ""}
                      max={isOpen?.permission_at_field5?.max ? isOpen?.permission_at_field5?.max : ""}
                      maxLength={
                        isOpen?.permission_at_field5?.max
                          ? isOpen?.permission_at_field5?.max
                          : "12"
                      }
                      onInput={maxLengthCheck}
                      name="mlr_number"
                      value={formValue.mlr_number}
                      focus={
                        !!(typeof formError === "object" && formError?.mlr_number)
                      }
                      error={
                        !!(typeof formError === "object")
                          ? formError?.mlr_number
                          : ""
                      }
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                    />
                    <span className="outOf_cks"> {formValue?.mlr_number?.toString()?.length} / {isOpen?.permission_at_field5?.max ? isOpen?.permission_at_field5?.max : 12} </span>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}

          {(isOpen?.contract?.chargeable_on === 1) && <div className="pr_procssBx __docPrx_bx" style={{ marginBottom: "9px", marginRight: '30px' }}>
            <div className="_inrPrt_flx2">
              <div className="singleDiv">
                <CommonSwitch
                  id="freightReceivable"
                  name="Freight Receivable from Party"
                  label="Freight Receivable from Party"
                  value={freightRadioToggle}
                  checked={freightRadioToggle === true ? true : false}
                  onChange={(e) => setFreightRadioToggle(e.target.checked)}
                />
              </div>
              {freightRadioToggle ? (
                <>
                  <div className="_divForth">
                    <CustomSelect
                      label="Freight Type"
                      isDropdownTop={true}
                      value={formValue.freight_type}
                      options={isOpen?.contract?.rate_type?.map((el) => {
                        return {
                          label: el?.name,
                          value: el?.id,
                        };
                      })}
                      name="freight_type"
                      placeholder="Freight Type"
                      error={formError["freight_type.label"]}
                      onSelect={(data) => onhandleSelect(data, "freight_type")}
                    />
                  </div>

                  {formValue?.freight_type?.value != 6 && (<>
                    <div className="_divForth">
                      <CommonInput
                        type="number"
                        label="Qty"
                        placeholder="Qty "
                        name="total_qty"
                        maxLength="6"
                        onInput={maxLengthCheck}
                        value={formValue.total_qty > 0 ? formValue.total_qty : ''}
                        focus={
                          !!(typeof formError === "object" && formError?.total_qty)
                        }
                        error={
                          !!(typeof formError === "object")
                            ? formError?.total_qty
                            : ""
                        }
                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, value)
                        }
                      />
                    </div>

                    <div className="_divForth">
                      <CommonInput
                        type="number"
                        label="Rate"
                        placeholder="Rate "
                        name="rate"
                        maxLength="6"
                        onInput={maxLengthCheck}
                        value={formValue.rate > 0 ? formValue.rate : ''}
                        focus={!!(typeof formError === "object" && formError?.rate)}
                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                        error={
                          !!(typeof formError === "object") ? formError?.rate : ""
                        }
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, value)
                        }
                      />
                    </div>
                  </>)}

                  <div className="_divForth">
                    <CommonInput
                      type="number"
                      onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                      label="Amount (₹)"
                      placeholder="Amount "
                      name="total_amount"
                      maxLength="12"
                      onInput={maxLengthCheck}
                      value={(formValue?.freight_type?.value != 6) ? (formValue.rate * formValue.total_qty > 0 && formValue.rate * formValue.total_qty) : (formValue.total_amount > 0 ? formValue.total_amount : '')}
                      disabled={(formValue?.freight_type?.value != 6) ? true : false}
                      focus={
                        !!(
                          typeof formError === "object" && formError?.total_amount
                        )
                      }
                      error={
                        !!(typeof formError === "object")
                          ? formError?.total_amount
                          : ""
                      }
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                    />
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>}
        </div>

        <div className="rightNw_lrbx">
          <div className="Cbox_border_lr ">
            <h6>Eway Bill Details</h6>

            <div className="_csgAdd_bx">
              <div className="singleDiv mt-3">
                <CommonInput
                  type="number"
                  label={isOpen?.permission_at_lr?.eway_bill_mandatory === 1 ? `Eway Bill Number * ` : `Eway Bill Number`}
                  placeholder={isOpen?.permission_at_lr?.eway_bill_mandatory === 1 ? `Eway Bill Number * ` : `Eway Bill Number`}
                  name="eway_bill_number"
                  maxLength="12"
                  onKeyDown={(e) => lrHandleKeyDown(e, 'amount')}
                  onInput={maxLengthCheck}
                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                  value={formValue.eway_bill_number}
                  focus={
                    !!(
                      typeof formError === "object" &&
                      formError?.eway_bill_number
                    )
                  }
                  error={
                    !!(typeof formError === "object")
                      ? formError?.eway_bill_number
                      : ""
                  }
                  onChange={({ target: { name, value } }) =>
                    handleOnChange(name, value)
                  }
                />
                {/* <span className="outOf_cks"> {formValue?.eway_bill_number?.toString()?.length > 0 ? formValue?.eway_bill_number?.toString()?.length : 0} / 12 </span> */}
              </div>

              {(formValue?.eway_bill_number?.toString()?.length === 12) ?
                <React.Fragment>
                  <div className="singleDiv mt-4">
                    <CommonDatePicker
                      name="eway_bill_date"
                      label="Eway Start Date"
                      id={Math.random() * 100000}
                      maxDate={new Date()}
                      startDate={formValue?.eway_bill_date}
                      setStartDate={(data) => handleOnChange('eway_bill_date', data)}
                      error={!!(typeof formError === "object") ? formError?.eway_bill_date : ""}
                    />
                  </div>

                  <div className="singleDiv mt-4">
                    <CommonDatePicker
                      label="Eway End Date"
                      name="eway_expiry_date"
                      id={Math.random() * 10000}
                      showTimeSelect={false}
                      defaultTimeFix={true}
                      minDate={formValue?.eway_bill_date} // {ewayBillStartDate}
                      startDate={formValue?.eway_expiry_date}
                      setStartDate={(data) => handleOnChange('eway_expiry_date', data)}
                      error={!!(typeof formError === "object") ? formError?.eway_expiry_date : ""}
                    />
                  </div>
                </React.Fragment>
                :
                <></>
              }

              {!isOpen?.isEditLr && <button
                className={ewayBillLoading || !formValue?.branch_id?.value || !(formValue?.eway_bill_number?.toString()?.length === 12) ? '__fetchEwayBtn' : 'anime-btn __fetchEwayBtn'}
                onClick={(e) => handlePermissionCall(e)} // handleFetchEwayBillFunction(e)
                disabled={ewayBillLoading || !formValue?.branch_id?.value || !(formValue?.eway_bill_number?.toString()?.length === 12)}
              >
                {
                  ewayBillLoading ?
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div> : 'Fetch Eway Bill'
                }
              </button>}
            </div>
          </div>

          <div className="mt-4">
            <CommonTextarea
              type="textarea"
              label='Remarks'
              placeholder='Remarks'
              name='remarks'
              value={formValue.remarks}
              focus={!!(typeof formError === "object" && formError?.remarks)}
              error={!!(typeof formError === "object") ? formError?.remarks : ""}
              maxLength="500"
              onInput={utils.maxLengthCheck}
              onChange={({ target: { name, value } }) =>
                handleOnChange(name, value)
              }
            />
          </div>

          <div className="_inrPrt_flx2 mt-4">
            <div className="singleDiv ">
              <label className="attachFilelabel">
                <span className="title"> + Attachment </span>
                <input
                  className="FileUpload1"
                  name="booking_attachment"
                  id="file-input"
                  onChange={(e) => handleFileChange(e)}
                  type="file"
                  disabled={attachments?.length >= 5}
                  multiple
                />
              </label>
              {attachments?.length > 0 ? attachments?.map((file, index) => (
                < div className='img_fnex_src _rmRf_pd_file' key={index} >
                  <div className='__upFileDetail'>
                    <div className='__uplImg'>

                      {
                        file?.path?.split('.')?.at(-1) === 'pdf' ?
                          <span className='pdf_clsr-ct'>
                            <BsFillFileEarmarkPdfFill />
                          </span>
                          : (file?.path?.split('.')?.at(-1) === 'xlsx' || file?.path?.split('.')?.at(-1) === 'xls' || file?.path?.split('.')?.at(-1) === 'txt') ?
                            <span className='xlsx_clsr-ct'>
                              <BsFiletypeXlsx />
                            </span> :
                            <span className='__uplImg-ct'>
                              <FaRegImage />
                            </span>
                      }
                      <p>{`${file?.filename}`}</p>
                    </div>
                    <div className='__uplIcons _avPointer'>
                      {
                        !(file?.path?.split('.')?.at(-1) === 'pdf' || file?.path?.split('.')?.at(-1) === 'xlsx' || file?.path?.split('.')?.at(-1) === 'xls' || file?.path?.split('.')?.at(-1) === 'txt') &&
                        <MdOutlineRemoveRedEye onClick={() => setImagePreview({ url: `${masterData?.s3_url}${file?.path}`, preview: true })} style={{ fontSize: '18px', color: 'blue' }} />
                      }

                      <a href={`${masterData?.s3_url}${file?.path}`} target='_blank' className='__upDownload_ico' style={{ fontSize: '18px' }}>
                        <MdOutlineFileDownload />
                      </a>
                      <span className='__upCross_ico' style={{ fontSize: '18px' }} onClick={(e) => documentRemove(file?.path)}>
                        <RxCross2 />
                      </span>
                    </div>
                  </div>
                </div>
              )) : <></>}
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas-footer">
        {loading ? (
          <button className="_addComm_btn _sameWid __onloadingBtn" disabled>
            {" "}
            Loading...{" "}
          </button>
        ) : (
          <button
            className="_addComm_btn _sameWid"
            onClick={(e) => handleSubmit(e)}
            disabled={loading}
          >
            {" "}
            {!!isOpen?.isEditLr ? "Update LR" : "Add LR"}{" "}
          </button>
        )}
        <button className='_cancel_btn _avPointer' onClick={(e) => onClose(false)} >Cancel</button>
      </div>

      {isOpenLrSeries && <LrSeriesModal {...isLrSeriesModalProps} />}

      {showAddNewLrSeries && <AddNewSeriesModal {...addNewSeriesModalProps} />}

      {unitInLR && <SelectUnitLrModal {...unitInLrModal} />}

      {consigneeInLR && <SelectConsigneeLrModal {...consigneeInLrModal} />}

      {/* Add New Consignee Offcanvas - Start */}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${addNewConsignee ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: addNewConsignee ? "visible" : "hidden" }}
      >
        {addNewConsignee && (
          <AddAddressBook
            isOpen={addNewConsignee}
            onClose={(e) => setAddNewConsignee(false)}
            callBackAddressData={(e) => setConsigneeInLR(true)}
            selectedAssociateParty={isOpen}
            isLocationPoint={2}
            hideAddNewOption={false}
            firmId={isOpen?.firm_id}
          />
        )}
      </div>
      <div className={addNewConsignee ? "offBack_drop" : ""}></div>

      {/* Add New Consignee Offcanvas - End */}

      {/* Add New Unit Offcanvas - Start */}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${addNewUnit ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: addNewUnit ? "visible" : "hidden" }}
      >
        {addNewUnit && (
          <AddAddressBook
            isOpen={addNewUnit}
            onClose={(e) => setAddNewUnit(false)}
            callBackAddressData={(e) => setUnitInLR(true)}
            selectedAssociateParty={isOpen}
            isLocationPoint={1}
            hideAddNewOption={false}
            firmId={isOpen?.firm_id}
          />
        )}
      </div>
      <div className={addNewUnit ? "offBack_drop" : ""}></div>

      {/* Add New Unit Offcanvas - End */}

      {/* Add new branch offcanvas - start */}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${addNewBranch ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: addNewBranch ? "visible" : "hidden" }}
      >
        {addNewBranch && (
          <AddEditBranch
            isOpen={addNewBranch}
            onClose={(e) => setAddNewBranch(false)}
            hideAddNewOption={false}
            firmId={isOpen?.firm_id}
          />
        )}
      </div>
      <div className={addNewBranch ? "offBack_drop" : ""}></div>

      {/* Add new branch offcanvas - End */}

      {showAddItem && <AddItemModal {...firstAddItemModal} />}

      {showAddGroupItem?.modalValue && (
        <AddItemGroupModal {...firstAddGroupItemModal} />
      )}

      {openLoction && <AddLocationModal {...gmapLocate} />}

      {/* view address book modal like view unit , view consignee ---- start */}
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
      >
        {showOffcanvas && (
          <AddAddressBook
            isOpen={showOffcanvas}
            onClose={(e) => {
              setAddressId({ id: "", title: "address", view: false });
              setShowOffcanvas(false);
            }}
            id={addressId}
            callBackAddressData={callBackAddressData}
            hideAddNewOption={false}
            firmId={isOpen?.firm_id}
          />
        )}
      </div>
      <div className={showOffcanvas ? "offBack_drop" : ""}></div>
      {/* view address book modal like view unit , view consignee ---- start */}

      {/* Remove Attachement Modal Start */}
      {
        isDelete && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete ? </p>
          </CommonModal>
        )
      }
      {/* Remove Attachement Modal End */}

      {/* Attachement View Modal Start */}
      {
        imagePreview?.preview
        && (
          <ImagePreview {...storeModelProps} />
        )
      }
      {/* Attachement View Modal End */}

      {modalConfig.isOpen && <EbillExtentionModal
        {...ebillExpProps}
      />}

      {
        (youtubeVideos?.moduleName === 'lr_creation' && youtubeVideos?.moduleAction === true)
        && (
          <YoutubeModal {...youtubeProps} />
        )
      }
    </>
  );
};

export default React.memo(AddEditLrModal);
